import request from '@/utils/request'
/**
 *
 * 套餐管理
 *
 **/

// 查询列表数据
export const getSetmealPage = (params: any) => {
  return request({
    url: '/setmeal/page',
    method: 'get',
    params,
  },)
}

// 删除数据接口
export const deleteSetmeal = (ids: string) => {
  return request({
    url: '/setmeal',
    method: 'delete',
    params: { ids }
  })
}

// 修改数据接口
export const editSetmeal = (params: any) => {
  return request({
    url: '/setmeal',
    method: 'put',
    data: { ...params }
  })
}

// 新增数据接口
export const addSetmeal = (params: any) => {
  return request({
    url: '/setmeal',
    method: 'post',
    data: { ...params }
  })
}

// 查询详情接口
export const querySetmealById = (id: string | (string | null)[]) => {
  return request({
    url: `/setmeal/${id}`,
    method: 'get'
  })
}

// 批量上架禁售
export const setmealStatusByStatus = (params: any) => {
  return request({
    url: `/setmeal/status/${params.status}`,
    method: 'post',
    params: { id: params.ids }
  })
}

// 首页展示开关
export const setmealHomeDisplay = (params: { id: number | string; homeDisplay: 0 | 1 }) => {
  return request({
    url: `/setmeal/homeDisplay/${params.homeDisplay}`,
    method: 'post',
    params: { id: params.id }
  })
}

// 限时抢购开关（开启默认截止七天后）
export const setmealFlashSale = (params: { id: number | string; flashSale: 0 | 1 }) => {
  return request({
    url: `/setmeal/flashSale/${params.flashSale}`,
    method: 'post',
    params: { id: params.id }
  })
}

// 设置排序
export const setmealSetSort = (params: { id: number | string; sort: number; storeId: number }) => {
  return request({
    url: '/setmeal/sort',
    method: 'post',
    params
  })
}

//商品分类数据查询
export const dishCategoryList = (params: any) => {
  return request({
    url: `/category/list`,
    method: 'get',
    params: { ...params }
  })
}
